import React from "react";
import "../css/MarketSpaceDownload.css";
import { connect } from "react-redux";
import * as ActionTypes from "../actions/types";


class MarketSpaceDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            snackbarActive: false,
            snackbarMessage: "",
            currentPage: 1,
            itemsPerPage: 8,
            bannerImage: null, // To store the selected banner image
            iconImage: null, // To store the selected icon image
            offerInPercentage: "", // Store the value for offer in percentage
            couponId: "", // Store the value for coupon id
            fields: [], // Store the list of input field sets
            name: "",
            subData:[],
            actualData:[],
            features: "",
            description: "",
            editorChoice: false,
            mostDownloaded: false,
            personalized: false,
            aiEnabled: false,
            freeTrialPeriod: 0,
            costPerDownload: "",
            status: "inactive",
            activeData: [],
            tableData: [],
            doewnloadsData: [],
            active_usersData: [],
            downloads: Array.from({ length: 20 }).map((_, index) => ({
                name: `John Doe ${index + 1}`,
                email: `johndoe${index + 1}@example.com`,
                details: `Details ${index + 1}`,
            })),
        };
    }

    // Logic to change page
    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    };


    componentDidMount() {
        // Extract 'id' from the query parameters (e.g., URL like /marketspaceFormEdit?id=15)
        const searchParams = new URLSearchParams(window.location.search);
        const itemId = searchParams.get("id"); // Get the `id` query parameter

        if (itemId) {
            this.fetchActiveService(itemId);
            this.fetchActiveServiceTableData(itemId);
            this.fetchSubscriptions();
        } else {
            console.warn("No ID provided in the URL. Cannot fetch specific data.");
        }
    }

    fetchActiveService = (itemId) => {

        this.setState({ loader: true });
        const tokenStored = localStorage.getItem("token");
        const headers = {
            Authorization: `Token ${tokenStored}`,
            "X-CSRFToken": localStorage.getItem("csrftoken"),
        };

        fetch(`/cloud/apps/${itemId}`, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (response.status === 403) {
                    // Remove session data
                    localStorage.removeItem("token");
                    localStorage.removeItem("csrftoken");
                    localStorage.removeItem("auth");
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                // Find the specific record by ID
                // const selectedData = data.find((item) => item.id === parseInt(itemId));
                // console.log(data)
                if (!data.id) {
                    console.error("No matching data found for the provided ID.");
                    this.setState({ loader: false });
                    return;
                }

                // Populate state with specific data for editing
                this.setState({
                    id: data.id,
                    activeData: data, // All data in case it's still needed
                    doewnloadsData: data.downloads,
                    active_usersData: data.active_users,
                    bannerImage: data.banner_image,
                    iconImage: data.icon_image,
                    name: data.name || "",
                    features: data.features || "",
                    description: data.description || "",
                    editorChoice: data.editor_choice || false,
                    mostDownloaded: data.most_downloaded || false,
                    personalized: data.personalized || false,
                    aiEnabled: data.ai_enabled || false,
                    freeTrialPeriod: data.free_trial_period || 0,
                    costPerDownload: data.cost_per_download || "",
                    fields: typeof data.offers === "string" ? JSON.parse(data.offers) : [],


                    loader: false,
                });

            })
            .catch((err) => {
                console.error(err);
                this.setState({ loader: false });
            });
    };


    // Subscription  || Personalization fetch data // 

    fetchSubscriptions = () => {
        this.setState({
          loader: true
        })
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          'Authorization': tokenStored
        }
        fetch('/cloud/subscriptionApi/', {
          method: "GET",
          headers: headers,
        })
                   .then(response => {
                  if(response.status===403){
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({forceRefresh: true})
                    window.location.href ='/session-timeout'
                  }else{
                      return response.json()}
                  })
          .then(data => {
            let subData = data.all_subscriptions;
            // console.log(subData)
            data.all_subscriptions.forEach((subElement) => {
              if (subElement.subscription_status === 'expired') {
                this.setState({
                  unAssinedBoxes: this.state.unAssinedBoxes + 1
                })
              }
              if (subElement.osubscription_status === 'active') {
                this.setState({
                  assinedBoxesSI: this.state.assinedBoxesSI + 1
                })
              }
              if (subElement.subscription_status === 'about_to_expire') {
                this.setState({
                  assinedBoxesProjects: this.state.assinedBoxesProjects + 1
                })
              }
            })       
            this.setState({
              subData: subData,
              actualData: subData,
              loader: false
            },()=>{
            //   this.paginationFunction();
            })
            console.log('subData:',data.all_subscriptions)  
          })          
          .catch((err)=>{
            console.log(err)
          })
      }




    //Table Data Section

    fetchActiveServiceTableData = (itemId) => {

        this.setState({ loader: true });
        const tokenStored = localStorage.getItem("token");
        const headers = {
            Authorization: `Token ${tokenStored}`,
            "X-CSRFToken": localStorage.getItem("csrftoken"),
        };

        fetch(`/cloud/app/${itemId}/projects/`, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (response.status === 403) {
                    // Remove session data
                    localStorage.removeItem("token");
                    localStorage.removeItem("csrftoken");
                    localStorage.removeItem("auth");
                } else {
                    return response.json();
                }
            })
            .then((tabledata) => {
                console.log(tabledata);

                // Check if 'buildings' array exists and if it contains at least one item
                if (!tabledata.buildings || tabledata.buildings.length === 0 || !tabledata.buildings[0].id) {
                    console.error("No matching data found for the provided ID.");
                    this.setState({ loader: false });
                    return;
                }

                // Populate state with specific data for editing
                this.setState({
                    tableData: tabledata.buildings,  // Assign the whole buildings array to the state
                    loader: false,
                });


            })
            .catch((err) => {
                console.error(err);
                this.setState({ loader: false });
            });
    };

    // Pagination: Get the current page data
    getCurrentPageData = () => {
        const { downloads, currentPage, itemsPerPage } = this.state;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return downloads.slice(startIndex, endIndex);
    };

    render() {
        const { currentPage, itemsPerPage, downloads ,tableData} = this.state;
        // const totalPages = Math.ceil(downloads.length / itemsPerPage);
        const totalItems = tableData.length; // Use tableData instead of downloads if you're paginating tableData
        const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage)); // Ensure at least 1 page is displayed
    
        const {
            bannerImage,
            name,
            doewnloadsData,
            features,
            active_usersData,
            description,
        } = this.state;



        return (
            <div className="section-background-download">
                <div className="download-container">
                    {/* Remote Access Section */}
                    <div className="tile-access-container">
                        <div className="tile-access-illustration">
                            <img
                                src={bannerImage}
                                alt="Girl on swing"
                                className="illustration-image"
                                style={{ width: '180px', height: '200px', objectFit: 'contain' }}
                            />
                        </div>
                        <div className="tile-access-info">
                            <h3>{name}</h3>
                            <p style={{ width:'75%'}}>{features} </p>

                            <p style={{marginTop:'15px'}}>
                                Non-active: <strong>{doewnloadsData}</strong> Downloads | <strong>{active_usersData}</strong> Active Users
                            </p>
                        </div>
                    </div>
                    {/* Remote Access Section End */}

                    <br />
                    <br />

                    <div className="table-container">
                        <div className="table-title-short-section">
                            <h4 style={{fontSize:'18px'}}>DOWNLOAD REPORT</h4>
                            <div className="download-info">
                                {/* <div className="sort-by">
                                    <label htmlFor="sort-by">Sort by:</label>
                                    <select id="sort-by" name="sort-by">
                                        <option value="monthly">Monthly</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="daily">Daily</option>
                                    </select>
                                </div> */}
                            </div>
                        </div>
                        {/* <br /> */}

                        <h2 className="downloads">{doewnloadsData}+ DOWNLOAD</h2>
                        {/* <br /> */}

                        {/* Table Section */}
                        {
                            name === "Personalization" ?   <table className="download-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email ID</th>
                                    <th>SI Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.subData.length > 0 ? (
                                    this.state.subData.map((row, index) => (
                                        <tr key={index}>
                                            
                                            <td>{row.owner_name}</td>
                                            <td>{row.client_email}</td>
                                            <td>{row.si_name}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="1">No Data Available</td> {/* Adjust colSpan if you have more columns */}
                                    </tr>
                                )}
                            </tbody>

                        </table> : 
                       
                        <table className="download-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email ID</th>
                                    <th>SI Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.tableData.length > 0 ? (
                                    this.state.tableData.map((row, index) => (
                                        <tr key={index}>
                                            
                                            <td>{row.name}</td>
                                            <td>{row.email}</td>
                                            <td>{row.si_email}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="1">No Data Available</td> {/* Adjust colSpan if you have more columns */}
                                    </tr>
                                )}
                            </tbody>

                        </table>
                         }
                        {/* Table Section End */}

                        <br />
                        {/* Pagination Section */}
                        {/* <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={() => this.handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            <span className="pagination-info">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                className="pagination-btn"
                                onClick={() => this.handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div> */}
                        {/* Pagination Section End */}

                          {/* Pagination Section */}
                    {totalItems > itemsPerPage && (
                        <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={() => this.handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                            <span className="pagination-info">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                className="pagination-btn"
                                onClick={() => this.handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    )}
                    {/* Pagination Section End */}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redux: state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchBarActivate: (data) =>
            dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketSpaceDownload);
